<template>
  <div class="shop-attention">
    <el-table :data="tableData" ref="table">
      <el-table-column :label="$t('shopAttention.col1')" width="120px">
        <template slot-scope="scope">
          <el-image
            :src="imgUrlFilter(scope.row.ShopHeadPhoto)"
            fit="cover"
            class="image"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column :label="$t('shopAttention.col2')">
        <template slot-scope="scope">
          <div class="row-product-name">
            {{ scope.row.ShopName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('shopAttention.col3')">
        <template slot-scope="scope">
          <el-button-group>
            <el-button
              type="primary"
              size="small"
              @click="toStore(scope.row.ShopId)"
              >{{ $t("shopAttention.viewStore") }}</el-button
            >

            <el-button
              type="danger"
              size="small"
              @click="addFollowShop(scope.row.ShopId)"
              >{{ $t("shopAttention.cancelFollow") }}</el-button
            >
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      :current-page="page"
      :page-sizes="[1, 5, 10, 15, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "shopAttention",
  data() {
    return {
      OrderCount: {},
      state: null,
      page: 1,
      pageSize: 20,
      count: 0,
      lastPage: 0,
      tableData: []
    };
  },
  created() {
    this.request(this.state, this.page);
  },
  methods: {
    ...mapActions(["getCUser"]),
    toStore(shopId) {
      this.$router.push({
        path: "/store",
        query: { ShopId: shopId }
      });
    },
    request(state, page) {
      
      const param = {
        PageIndex: page,
        PageSize: this.pageSize
      };
      if (state !== null) {
        param.ScreenValues = state;
      }
      this.$api.cFollow
        .followShopByPage(param)
        .then(res => {
          this.state = state;
          this.page = res.meta.page;
          this.count = res.meta.total;
          this.lastPage = res.meta.lastPage;
          this.tableData = res.data;
          
        })
        .catch(err => {
          
          this.$message.error(err.message);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.request(this.state, this.page);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.request(this.state, this.page);
    },
    stateChangeAction(state) {
      if (this.state === state) return;
      this.request(state, 1);
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value.split("|")[0]);
    },
    addFollowShop(shopId) {
      
      var param = {
        ShopId: shopId,
        IsFollow: 0
      };
      this.$api.cFollow
        .addFollowShop(param)
        .then(() => {
          
          this.$message({
            message:this.$t("B2C.success"),
            type: "success"
          });
          this.request(this.state, this.page);
        })
        .catch(err => {
          
          this.$message.error(err.message);
        });
    },
  }
};
</script>

<style lang="scss" scoped>

.shop-attention {
  padding: 50px;
  .image {
    width: 66px;
    height: 66px;
    flex-shrink: 0;
  }
  .row-product-name {
    font-size: 12px;
    color: #333;
  }
  .row-product-price {
    margin: 0;
    font-size: 12px;
    color: #ff5852;
  }
  .row-product-state {
    margin: 0;
    font-size: 12px;
    color: #25b9ff;
  }
  .el-pagination {
    margin-top: 2%;
    margin-bottom: 2%;
    text-align: right;
  }
}
</style>
